const abPop = {
  namespaced: true,
  state: {
    paramsConfig: {}, // 后台的参数管理配置
    rechargeProps: { // 充值浮层参数
      curCostCoins: '0',
      scene: '非剧集触发', // 剧集解锁触发、非剧集触发（除剧集解锁、福利中心任务、自定义弹窗点击的触发方式以外，都上报非剧集触发）、金币挂件触发、充值促销弹窗触发、福利中心充值任务触发、自定义弹窗点击、金刚位触发
      from: 2 // 弹窗拉起来源 1-解锁视频  2-其他来源 3-其他 4-其他
    },
    ABClickReferer: '', // ab弹窗触发来源
    isClickFollowPop: false,
    popRechargeDCountDownTime: 0, // 充值样式D倒计时
    popClosePrecacheObj: null, // 弹窗关闭预缓存对象 {currentPop: 当前弹窗,closeOpenPop: 当前弹窗关闭打开的弹窗}
    payParams: {} // 充值方法传参(充值挽留弹窗使用)
  },
  mutations: {
    SET_ISCLICKFOLLOWPOP: (state, data) => {
      state.isClickFollowPop = data
    },
    SET_PAYPARAMS: (state, data) => {
      console.log('充值方法传参', data)
      state.payParams = data
    },
    SET_POPRECHARGEDCOUNTDOWNTIME: (state, data) => {
      state.popRechargeDCountDownTime = data
    },
    SET_PARAMSCONFIG: (state, data) => {
      state.paramsConfig = data
      console.log('paramsConfig', data)
    },
    SET_RECHARGEPROPS: (state, data) => {
      state.rechargeProps = data
    },
    SET_ABCLICKREFERER: (state, data) => {
      state.ABClickReferer = data
    },
    SET_POPCLOSEPRECACHEOBJ: (state, data) => {
      state.popClosePrecacheObj = data
    }
  },
  actions: {

  }
}
export default abPop
